import styles from "./ConfirmDialog.css";
import { useEffect, useRef } from "react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function ConfirmDialog(props){
  const ref = useRef(null); // Create ref for confirmation box
  useEffect(() => {
    const onBodyClick = (event) => {
      // contains belong to all dom elements
      if (
        ref.current != null &&
        event.target instanceof Node &&
        ref.current.contains(event.target)
      ) {
        return;
      }
      props.onDismiss();
    };

    document.body.addEventListener("click", onBodyClick, { capture: true });

    return () => {
      document.body.removeEventListener("click", onBodyClick, {
        capture: true,
      });
    };
  }, [props]);

  if (props.open) {
    return (
      <div className={cx("confirm-dialog-wrapper")}>
        <div
          className={cx("content")}
          ref={ref}
        >
          <h3 className={cx("title")}>
            {props.title}
            {props.closeWindow && <button class="close-window" onClick={props.onCloseWindow}>X</button>}
          </h3>
          <div className="mt-4">{props.message}</div>

          {props.confirmButton && <button onClick={props.onConfirm}>{props.confirmButtonContent}</button>}
          {props.dismissButton && <button onClick={props.onDismiss}>{props.dismissButtonContent}</button>}
          
          
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
